import { createContext, useContext } from "react";
import { useDrivers } from "../hooks";
const Context = createContext();

export const DriversProvider = ({ children }) => {
  return <Context.Provider value={useDrivers()}>{children}</Context.Provider>;
};

export const useDriversContext = () => useContext(Context);
